import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Button, Box, Typography, CircularProgress } from "@material-ui/core"
import crewmamaCrown from "../../assets/images/crewmama_crown.svg"
import styles from "./styles"

const ChangeRepresentativeButton = ({
  repName = "",
  onClickFn = () => {},
  loading = false,
}) => {
  const classes = styles()

  return (
    <Fragment>
      <Button
        style={{ display: "flex" }}
        onClick={onClickFn}
        disabled={loading}
        classes={{ root: classes.button }}
        disableRipple
      >
        <img
          src={crewmamaCrown}
          alt="Crew Mama"
          className={classes.representativeLogo}
        />
        <Box>
          <Typography
            variant="caption"
            className={classes.label}
            style={{
              opacity: loading ? 0.5 : 1,
            }}
          >
            Rep Name: {repName || ""}
          </Typography>
          {loading && (
            <CircularProgress size={18} style={{ position: "absolute" }} />
          )}
        </Box>
      </Button>
    </Fragment>
  )
}

ChangeRepresentativeButton.propTypes = {
  repName: PropTypes.string,
  onClickFn: PropTypes.func,
  loading: PropTypes.bool,
}

export default ChangeRepresentativeButton
